import { OrganizationKeyName } from "../../../model/Organization";

export const GET_UNASSIGNED_NEWS_LIST = "SHOP:GET_UNASSIGNED_NEWS_LIST";

export const getUnassignedNewsListAction = (
  organization: OrganizationKeyName
) => ({
  type: GET_UNASSIGNED_NEWS_LIST as typeof GET_UNASSIGNED_NEWS_LIST,
  organization,
});

export type GetUnassignedNewsListAction = ReturnType<
  typeof getUnassignedNewsListAction
>;
